export default __webpack_public_path__ + "static/media/navigate-seat.ae5bd786.png";